import { call, put, select, all } from 'redux-saga/effects';
import HeroUsersAPI from 'api-services/HeroUserApi';
import HeroSessionAPI from 'api-services/HeroSessionApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { doneStartingSession } from '../sessions/actionCreators';
import { doneGettingUserStatus } from '../userLogin/actionCreators';
import { authAccessParamsSelector } from '../auth/selectors';
import { selectedAccountIdSelector } from '../userStatus/selectors';
import { logout } from '../auth/actionCreators';
export function* checkUserHelper(constAccessParams) {
    const [authAccessParams, selectedAccountId] = yield all([select(authAccessParamsSelector), select(selectedAccountIdSelector)]);
    const accessParams = Object.assign(Object.assign({}, constAccessParams), authAccessParams);
    return Object.assign(Object.assign({}, accessParams), { selected_account_id: selectedAccountId, statusCode: 0 });
}
export function* checkBackofficeUserHelper(constAccessParams) {
    const authAccessParams = yield select(authAccessParamsSelector);
    const accessParams = Object.assign(Object.assign({}, constAccessParams), authAccessParams);
    return Object.assign(Object.assign({}, accessParams), { statusCode: 0 });
}
export function* startSessionHelper(constAccessParams) {
    const authAccessParams = yield select(authAccessParamsSelector);
    const accessParams = Object.assign(Object.assign({}, constAccessParams), authAccessParams);
    const result = yield call(HeroSessionAPI.startSession, accessParams);
    if (isSuccessResponse(result)) {
        yield put(doneStartingSession({ session_id: result.data.session_id }));
        return result.data.session_id;
    }
    return null;
}
export function* checkSessionHelper(constAccessParams) {
    const [authAccessParams, selectedAccountId] = yield all([select(authAccessParamsSelector), select(selectedAccountIdSelector)]);
    const accessParams = Object.assign(Object.assign(Object.assign({}, constAccessParams), authAccessParams), { selected_account_id: selectedAccountId });
    const result = yield call(HeroUsersAPI.userStatus, accessParams);
    if (isSuccessResponse(result)) {
        yield put(doneGettingUserStatus(result.data));
        if (result.data.sessions.length &&
            result.data.sessions[result.data.sessions.length - 1].status !== 'release_candidate') {
            return result.data.sessions[result.data.sessions.length - 1].session_id;
        }
        return null;
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    return null;
}
export function* checkSessionAndStatusHelper(constAccessParams) {
    const [authAccessParams, selectedAccountId] = yield all([select(authAccessParamsSelector), select(selectedAccountIdSelector)]);
    const accessParams = Object.assign(Object.assign(Object.assign({}, constAccessParams), authAccessParams), { selected_account_id: selectedAccountId });
    const result = yield call(HeroUsersAPI.userStatus, accessParams);
    if (isSuccessResponse(result)) {
        yield put(doneGettingUserStatus(result.data));
        if (result.data.sessions.length &&
            result.data.sessions[result.data.sessions.length - 1].status !== 'release_candidate') {
            return {
                currentSession: result.data.sessions[result.data.sessions.length - 1].session_id,
                accountId: result.data.account_id
            };
        }
        return null;
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    return null;
}
//# sourceMappingURL=helperSagas.js.map